/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Einvoice_Credential_Verified_AtInputs */

const vi_einvoice_credential_verified_at = /** @type {(inputs: Einvoice_Credential_Verified_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kiểm tra gần nhất: ${i?.time}`)
};

/**

* @param {Einvoice_Credential_Verified_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_credential_verified_at = /** @type {((inputs: Einvoice_Credential_Verified_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Credential_Verified_AtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_credential_verified_at(inputs)
});